import { render } from "./DialogNewGeoDisitributionCreateWait.vue?vue&type=template&id=e99c86ba"
import script from "./DialogNewGeoDisitributionCreateWait.vue?vue&type=script&lang=js"
export * from "./DialogNewGeoDisitributionCreateWait.vue?vue&type=script&lang=js"

import "./DialogNewGeoDisitributionCreateWait.vue?vue&type=style&index=0&id=e99c86ba&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__